export default function orderStatus(positionalA /*, positionalB, named*/) {
  switch (positionalA) {
    case 'created':
      return 'erstellt';
    case 'ordered':
      return 'bestellt';
    case 'canceled':
      return 'abgebrochen';
    case 'delivered':
      return 'geliefert';
    default:
      return '(unbekannter Status)';
  }
}
